module.exports = __webpack_public_path__ + "static/media/checkgreen.47c52867.svg";